import { Component, OnInit } from "@angular/core";
import { DataService } from "../../data.service";
import { DecimalPipe } from "@angular/common";
import { Achat } from "../../model/achat";
import { Article } from "../../model/article";
import { Vente } from "../../model/vente";
import { Fournisseur } from "../../model/fournisseur";
import { AuthenticationService } from "../../authentication.service";
import { Variation } from "../../model/variation";
import { MessageService } from 'primeng/api';
import { environment } from "../../../environments/environment";
@Component({
  selector: "app-variation-stock",
  templateUrl: "variation-stock.component.html",
  styleUrls: ["variation-stock.component.scss"],
  providers: [DecimalPipe],
})
export class VariationStockComponent implements OnInit {

  tableArticles: Achat[];
  Achat: Achat = {};
  Achats: Achat[];
  Variation: Variation = {};
  Variations: Variation[];
  tableVariations: Variation[];
  displayDialog: boolean;
  Vente: Vente = {};
  Ventes: Vente[];
  Article: Article = {};
  Articles: Article[];
  Fournisseur: Fournisseur = {};
  Fournisseurs: Fournisseur[];
  selectedAchat: Achat;
  selectedVariation: Variation;
  blockedDocument: boolean = false;
  displayDialogArticle: boolean = false;
  myUrl: string = `${environment.urlApi}`;
  able: boolean =false;
  designation:string="";
  depot:string="";
  stock :number;
  totalAchat :number;
  totalVente :number;
  totalAvoir :number;
  totalVariation :number;

  constructor(
    private data: DataService,
    private _decimalPipe: DecimalPipe,
    public AuthenticationService: AuthenticationService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    if(this.AuthenticationService.currentUserValue.groupe=='Administrateur' || this.AuthenticationService.currentUserValue.groupe=='Administrateurs' ){
      this.able=true;
    }
    this.Variation.dateVariation = new Date().toISOString().split("T")[0];
    this.getStock();
    // this.variation();
    // this.getStockVendu();
    // this.fournisseur();
  }
getStock() {
    this.Achat.action = "Stock";
    this.data
      .stock(this.Achat)
      .toPromise()
      .then((x: Achat[]) => (
          this.Achats = x,
          this.tableArticles = x,
          this.variation() 
          // this.getStockVendu(),
          // console.log(x)
      ));
  }
  variation() {
    this.Variation.action = "Select";
    this.data
      .variationStock(this.Variation)
      .toPromise()
      .then(
        (x: Variation[]) => ((this.Variations = x), (this.tableVariations = x),this.remplirTableAchats())
      );
  }

  remplirTableAchats(){
    this.Achats.forEach((row ,index )=>{
      if(row.depot==null){
         this.Achats[index].depot = '---';
      } 
      })
    this.tableVariation()
  }
  tableVariation(){
    if (this.tableArticles.length!=undefined){
      // console.log(this.tableRecapPaiements);
        this.tableArticles.forEach((row ,index )=>{
          let updateItem = this.Variations.filter(item=>item.idArticle==row.idArticle);
          // console.log(updateItem);
          if (updateItem===undefined){
            this.tableArticles[index].quantite =0;  
          }else{
              let total=0;
              total = updateItem
              .map((t) => t.quantite * 1)
              .reduce((a, value) => a + value, 0);
              this.tableArticles[index].quantite =total;       
          }

        }); 
      this.filter();
    }
}
  filter() {
    if (this.depot===undefined || this.depot==null){
      this.depot='';
    }
    if (this.designation===undefined|| this.designation==null){
      this.designation='';
    }
      let recherche = this.Achats.filter(
        (x) =>
        x.designation.toLocaleLowerCase().indexOf(this.designation.toLocaleLowerCase()) > -1 && 
        x.depot.toLocaleLowerCase().indexOf(this.depot.toLocaleLowerCase()) > -1 
      );
      this.tableArticles = recherche;
  }

  showArticle(){
    this.displayDialogArticle=true;
    this.displayDialog = false;
  }
  save() {
    // alert('update');
    this.Variation.action = "Update";
    this.Variation.quantite = this.Variation.stock - (this.totalAchat-this.totalVente+this.totalAvoir+this.totalVariation)+this.totalVariation;
    console.log(this.Variation);
    this.data
      .variationStock(this.Variation)
      .toPromise()
      .then((res: { message: string }) => {
        if (res.message == "Opération de modification réuissie") {
          this.messageService.add({severity:'success', summary: 'Sauvegarde', detail: res.message});
          this.Variation = {};
          this.getStock();
          this.displayDialog = false;
        } else {
          alert(res.message);
        }
      });
  }
  addVariation() {
    this.Variation.action = "Insert";    
    this.Variation.quantite = this.Variation.stock - (this.Variation.totalAchat-this.Variation.totalVente+this.Variation.totalAvoir+this.Variation.totalVariation);
    this.data
      .variationStock(this.Variation)
      .toPromise()
      .then((res: { message: string }) => {
        if (res.message == "Opération de modification réuissie") {
          this.messageService.add({severity:'success', summary: 'Sauvegarde', detail: res.message});
          this.Variation = {};
          this.getStock();
          this.displayDialog = false;
        } else {
          alert(res.message);
          this.displayDialog = false;
        }
      });
  }

  deleteVariation() {
    if (confirm("êtes vous sure?" + this.Variation.id)) {
      this.Variation.action = "Delete";
      // console.log(this.Variation);
      this.data
        .variationStock(this.Variation)
        .toPromise()
        .then((res: { message: string }) => {
          if ((res.message = "Opération de supression réuissie")) {
            this.messageService.add({severity:'warn', summary: 'Supression', detail: res.message});
            this.displayDialog = false;
            this.Variation = {};
            this.getStock();
          } else {
            alert("Nonnnn");
          }
        });
    }
  }
  deleteArticle(idArticle) {
    if (confirm("êtes vous sure de supprimer cet article ?")) {
      this.blockedDocument=true;
      this.Article.action = "Delete";
      this.Article.id = idArticle;
      this.Article.dateNow = new Date().toISOString().split("T")[0]; 
      console.log(this.Article);
      this.data
        .article(this.Article)
        .toPromise()
        .then((res: { message: string }) => {
          if ((res.message = "Opération de supression réuissie")) {
            this.messageService.add({severity:'warn', summary: 'Supression', detail: res.message});
            this.blockedDocument=false;
            this.displayDialog = false;
            this.getStock();
          } else {
            alert("Nonnnn");
          }
        });
    }
  }
  newDonnee: boolean;
  showDialogToAdd() {
    this.newDonnee = true;
    this.Variation = {};
    this.displayDialog = true;
  }
  onRowSelect(event) {
    this.displayDialog = true;
    this.Variation.dateVariation = new Date().toISOString().split("T")[0];
    this.Variation.idDepot = event.data.idDepot;
    this.Variation.idArticle = event.data.idArticle;
    this.Variation.totalAchat = event.data.totalAchat;
    this.Variation.totalVente = event.data.totalVente;
    this.Variation.totalAvoir = event.data.totalAvoir;
    this.Variation.totalVariation = event.data.totalVariation;
    this.Variation.quantite = event.data.totalVariation;

    this.stock = event.data.stock;
    this.totalAchat = event.data.totalAchat;
    this.totalVente = event.data.totalVente;
    this.totalAvoir = event.data.totalAvoir;
    this.totalVariation = event.data.totalVariation;
    
    // alert(event.data.quantite);
    let recherche = this.Variations.filter(
      (x) => x.idArticle == event.data.idArticle && x.idDepot == event.data.idDepot
    );
    if (recherche != undefined) {
      this.tableVariations = recherche;
    } else {
      // return 'vide';
    }
    // alert(this.tableVariations);
  }
  onRowSelectVariation(event) {
    // alert(event.data.dateVariation);
    // console.log(event.data);
    this.newDonnee = false;
    this.Variation = this.cloneDonnee(event.data);
  }
  cloneDonnee(c: Variation): Variation {
    let Variation = {};
    for (let prop in c) {
      Variation[prop] = c[prop];
    }
    return Variation;
  }
  close() {
    this.displayDialog = false;
    this.Variation = {};
  }
}
